<template>
    <div>
        <div container-table>
            <header>
                <h1 class="d-flex justify-content-center">Admin Analysis</h1>
            </header>
            <div class="py-1">
                <div class="container-form">
                    <div class="reset-col-btn">
                        <button v-if="loaded" class="btn btn-primary mb-1" @click="resetColumns()">Reset Columns</button>
                    </div>
                    <div class="table-content">
                        <b-spinner class="center-spinner" v-if="!loaded" variant="primary" label="Spinning"></b-spinner>
                        <div class="row" v-if="loaded">
                            <div class="d-flex flex-grow-1 justify-content-center">
                                <ag-grid-vue style="width: 100%; height: 700px;"
                                             class="ag-theme-balham"
                                             :gridOptions="gridOptions"
                                             :columnDefs="columnDefs"
                                             :rowData="rowData"
                                             rowSelection='single'>
                                </ag-grid-vue>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!--<div class="py-1">
            <div class="container">
                <div class="d-flex justify-content-end">
                    <button v-if="loaded" class="btn btn-primary mb-1" @click="resetColumns()">Reset Columns</button>
                </div>
                <div class="row">
                    <div class="col-md-12">
                        <b-spinner class="center-spinner" v-if="!loaded" variant="primary" label="Spinning"></b-spinner>
                        <div class="row" v-if="loaded">
                            <div class="d-flex flex-grow-1 justify-content-center">
                                <ag-grid-vue style="width: 100%; height: 100%;"
                                             class="ag-theme-balham"
                                             :gridOptions="gridOptions"
                                             :columnDefs="columnDefs"
                                             :rowData="rowData"
                                             rowSelection='single'
                                             domLayout='autoHeight'>
                                </ag-grid-vue>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>-->
    </div>
</template>

<style lang="scss">

    .reset-col-btn {
        padding-left: 3em;
        align-self: flex-end;
    }
    /* Works on Chrome, Edge, and Safari */

    ::-webkit-scrollbar {
        width: 10px;
    }

    ::-webkit-scrollbar-track {
        background: transparent;
    }

    ::-webkit-scrollbar-thumb {
        background-color: rgba(155, 155, 155, 0.5);
        border-radius: 20px;
        border: transparent;
    }

    body {
        overflow: hidden;
    }


</style>

<script>
    import ReportService from '@/services/ReportService'
    import { AgGridVue } from "ag-grid-vue";
    import DateService from '../services/DateService'

    export default {
        data: function () {
            return {
                columnDefs: null,
                gridOptions: null,
                rowData: null,
                loaded: false
            }
        },
        components: {
            AgGridVue
        },
        async beforeMount() {
            let self = this;
            this.gridOptions = {
                defaultColDef: {
                    filter: true, // set filtering on for all cols
                    sortable: true,
                    cellClass: "cell-wrap-text",
                    autoHeight: true,
                    resizable: true,
                    flex: 1,
                    minWidth: 100,
                },
                onRowSelected: function(event) {
                    self.$router.push(event.node.data.ReportLink);
                },
                rowSelection: 'single'
            }

            const caseInsensitiveComparator = (valueA, valueB) => {
                if (!valueA || !valueB) {
                    return true;
                }

                return valueA.toLowerCase().localeCompare(valueB.toLowerCase());
            };

            this.columnDefs = [
                {
                    headerName: 'Submitted Date', field: 'SubmittedDate',
                    cellRenderer: (params) => {
                        var text = document.createElement('div');
                        text.innerText = params.value ? (new Date(params.value)).toLocaleDateString() : '';
                        return text;
                    },
                    sort: "desc",
                    filter: "agDateColumnFilter",
                    valueFormatter: function (data) {
                        return data.value ? (new Date(data.value)).toLocaleDateString() : '';
                    },
                    filterParams: {
                        comparator: DateService.dateFilterComparator
                    }
                },
                {
                    headerName: 'Paid Date', field: 'PaidDate',
                    cellRenderer: (params) => {
                        var text = document.createElement('div');
                        text.innerText = params.value ? (new Date(params.value)).toLocaleDateString() : '';
                        return text;
                    },
                    filter: "agDateColumnFilter",
                    valueFormatter: function (data) {
                        return data.value ? (new Date(data.value)).toLocaleDateString() : '';
                    },
                    filterParams: {
                        comparator: DateService.dateFilterComparator
                    }
                },
                {
                    headerName: 'Submitter Name', field: 'SubmitterName',
                    cellRenderer: (params) => {
                        var text = document.createElement('div');
                        text.innerText = params.value;
                        return text;
                    },
                    comparator: caseInsensitiveComparator
                },
                {
                    headerName: 'Approvals', field: 'Approvals',
                    cellRenderer: (params) => {
                        var text = document.createElement('div');
                        text.innerText = params.value;
                        return text;
                    },
                    comparator: caseInsensitiveComparator
                },
                {
                    headerName: 'Report Name', field: 'ReportName',
                    cellRenderer: (params) => {
                        var text = document.createElement('a');
                        text.href = "javascript:void(0)";
                        text.innerText = params.value;
                        return text;
                    },
                    comparator: caseInsensitiveComparator
                },
                {
                    headerName: 'Project(s)', field: 'Projects',
                    cellRenderer: (params) => {
                        var text = document.createElement('div');
                        text.innerText = params.value;
                        return text;
                    },
                    comparator: caseInsensitiveComparator
                },
                {
                    headerName: 'Type', field: 'Type', width: 75,
                    cellRenderer: (params) => {
                        var text = document.createElement('div');
                        text.innerText = params.value;
                        return text;
                    },
                    comparator: caseInsensitiveComparator
                },
                {
                    headerName: 'Status', field: 'Status',
                    cellRenderer: (params) => {
                        var text = document.createElement('div');
                        text.innerText = params.value;
                        return text;
                    },
                    comparator: caseInsensitiveComparator
                },
                {
                    headerName: 'Totals',
                    children: [
                        {
                            headerName: 'Air', field: 'AirfareTotal',
                            cellRenderer: (params) => {
                                var text = document.createElement('div');
                                text.innerText = params.value;
                                return text;
                            },
                            columnGroupShow: 'open'
                        },
                        {
                            headerName: 'Lodging', field: 'LodgingTotal',
                            cellRenderer: (params) => {
                                var text = document.createElement('div');
                                text.innerText = params.value;
                                return text;
                            },
                            columnGroupShow: 'open'
                        },
                        {
                            headerName: 'Meals', field: 'MealsTotal',
                            cellRenderer: (params) => {
                                var text = document.createElement('div');
                                text.innerText = params.value;
                                return text;
                            },
                            columnGroupShow: 'open'
                        },
                        {
                            headerName: 'Rental Car', field: 'CarRentalTotal',
                            cellRenderer: (params) => {
                                var text = document.createElement('div');
                                text.innerText = params.value;
                                return text;
                            },
                            columnGroupShow: 'open'
                        },
                        {
                            headerName: 'Other - Ground Transportation', field: 'GroundTransportationTotal',
                            cellRenderer: (params) => {
                                var text = document.createElement('div');
                                text.innerText = params.value;
                                return text;
                            },
                            columnGroupShow: 'open'
                        },
                        {
                            headerName: 'Other - POV Mileage', field: 'POVMileageTotal',
                            cellRenderer: (params) => {
                                var text = document.createElement('div');
                                text.innerText = params.value;
                                return text;
                            },
                            columnGroupShow: 'open'
                        },
                        {
                            headerName: 'Other - Misc Costs', field: 'MiscTotal',
                            cellRenderer: (params) => {
                                var text = document.createElement('div');
                                text.innerText = params.value;
                                return text;
                            },
                            columnGroupShow: 'open'
                        },
                        {
                            headerName: 'Misc Report', field: 'MiscReportItemTotal',
                            cellRenderer: (params) => {
                                var text = document.createElement('div');
                                text.innerText = params.value;
                                return text;
                            },
                            columnGroupShow: 'open'
                        },
                        {
                            headerName: 'Reimbursement Total', field: 'ReimbursementTotal',
                            cellRenderer: (params) => {
                                var text = document.createElement('div');
                                text.innerText = params.value;
                                return text;
                            },
                            columnGroupShow: 'open'
                        },
                        {
                            headerName: 'Reimbursement Total', field: 'ReimbursementTotal',
                            cellRenderer: (params) => {
                                var text = document.createElement('div');
                                text.innerText = params.value;
                                return text;
                            },
                            columnGroupShow: 'closed'
                        },
                    ]
                },
                
            ];

            const searchCriteria = {
                IncludeTotal: true,
                IsAnalysis: true
            }
            this.rowData = await ReportService.getAnalysisReport(searchCriteria)
            this.loaded = true;
        },
        methods: {
            resetColumns: function () {
                this.gridOptions.columnApi.resetColumnState();
            }
        }
    }
</script>